// automatically generated by the FlatBuffers compiler, do not modify

export enum EarthquakeStatus {
  Off = 0,
  On = 1,
  Normal = 2
}
